import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { palette } from "../../theme/palette";
import styled from "@emotion/styled";
import { Skeleton } from "@mui/material";
import classNames from "classnames";
const StyledSkeleton = styled(Skeleton)(({ style }) => ({
    borderRadius: "6px",
    backgroundColor: palette.bg040,
    transform: "scale(1,1)",
    ...style,
}));
export const GrSkeleton = (props) => {
    return _jsx(StyledSkeleton, { className: classNames("GrSkeleton", props.className), ...props });
};
//# sourceMappingURL=GrSkeleton.js.map